import { CreateSiteReqData, UpdateAllSiteContacts } from '@/shared/types/sites'
import { del, get, patch, post } from '@/shared/utils/api-utils'
import connector from './connector'
import {
  IndividualSite,
  InsertSite,
  Site,
  SiteTableData,
} from '@depanneo/types'
import { objectToFormData } from '@/shared/utils/file-upload-utils'

const createSite = async (data: CreateSiteReqData, files?: File[]) => {
  const formData = objectToFormData(
    { ...data, documents: files || [] },
    {
      filesField: 'documents',
      jsonFields: [
        'tags',
        'responsibleContact',
        'secondaryContacts',
        'operatingHours',
        'holidaySchedule',
        'customFields',
      ],
    }
  )

  const response = await connector.post<Site>('/sites', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}

const getSites = async () => {
  return await get<SiteTableData[]>('/sites')
}

const getSiteById = async (id: string) => {
  return await get<IndividualSite>(`/sites/${id}`)
}

const updateSite = async (id: string, data: InsertSite) => {
  return await patch<Site, Partial<Site>>(`/sites/${id}`, data)
}

const deleteSite = async (id: string) => {
  return await del<void>(`/sites/${id}`)
}

const bulkDeleteSites = async (ids: string[]) => {
  return await post<{ deleted: number; total: number }, { ids: string[] }>(
    '/sites/bulk-delete',
    { ids }
  )
}

const updateAllSiteContacts = async (
  id: string,
  data: UpdateAllSiteContacts
) => {
  return await patch<IndividualSite, typeof data>(
    `/sites/${id}/contacts/all`,
    data
  )
}

export {
  createSite,
  getSites,
  getSiteById,
  updateSite,
  deleteSite,
  bulkDeleteSites,
  updateAllSiteContacts,
}
